import { DataCard, DataCardContent } from '@/components/blocks/DataCard';
import { ExternalRedirectButton } from '@/components/blocks/buttons/ExternalRedirectButton';
import { CardTitle } from '@/components/ui/card';

interface ServiceCardProps {
  title: string;
  imageSrc: string;
  imageAlt: string;
  items: string[];
  buttonLabel: string;
  buttonHref: string;
}

export function ServiceCard({
  title,
  imageSrc,
  imageAlt,
  items,
  buttonLabel,
  buttonHref,
}: ServiceCardProps) {
  return (
    <DataCard imageSrc={imageSrc} imageAlt={imageAlt}>
      <DataCardContent>
        <CardTitle>{title}</CardTitle>
        <ul className="flex-1 space-y-1.5">
          {items.map((item) => (
            <li key={item} className="flex items-start gap-2 text-data-card-sm text-foreground">
              <span
                className="mt-1.5 size-1.5 shrink-0 rounded-full bg-muted-foreground/60"
                aria-hidden
              />
              {item}
            </li>
          ))}
        </ul>
        <ExternalRedirectButton href={buttonHref} label={buttonLabel} className="w-full" />
      </DataCardContent>
    </DataCard>
  );
}
